<template>
  <div>
    <v-layout row wrap mb-5>
      <v-flex class="text-xs-center">
        <h1>
          Llamada entrante
        </h1>
      </v-flex>
    </v-layout>
    <template v-if="!noCustomerForm">
      <v-layout row wrap justify-center mb-3>
        <v-flex md5>
          <v-text-field
            v-model="fiscal_id"
            prepend-icon="fas fa-search"
            placeholder="Ingrese Rut"
            solo
            flat/>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md5>
          <v-text-field
            v-model="customer_name"
            prepend-icon="fas fa-search"
            placeholder="Ingrese Nombre"
            solo
            flat/>
        </v-flex>
      </v-layout>
      <v-layout row wrap mt-2 mb-4 justify-center>
        <v-flex md5 class="text-xs-right">
          <a @click="noCustomerForm = true">
            No es cliente
          </a>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md5>
          <v-list class="elevation-0 py-0">
            <vue-perfect-scrollbar v-if="customers.length" class="scrollbar">
              <v-list-tile
                v-for="item in customers"
                :key="`customers-${item.id}`"
                :disabled="loading"
                @click="selectCustomer(item)">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <strong class="mr-4">{{ item.account }}</strong>
                    {{ item.name || (`${item.first_name} ${(item.last_name ? item.last_name : '')}`) }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider />
            </vue-perfect-scrollbar>
            <v-list-tile
              v-else
              class="py-1 text-xs-center no-rows">
              <v-icon class="mr-4">
                fas fa-exclamation-circle
              </v-icon>
              <p class="mb-0">
                No hay nada que mostrar
              </p>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-layout row wrap justify-center mb-3>
        <v-flex md5>
          <v-text-field
            v-model="form.fiscal_id"
            color="black"
            prepend-icon="fas fa-id-card-alt"
            placeholder="RUT/DNI/CI"
            :disabled="noCustomerSaved"
            solo
            flat/>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center mb-3>
        <v-flex md5>
          <v-text-field
            v-model="form.first_name"
            color="black"
            prepend-icon="fas fa-user"
            placeholder="Nombres"
            :disabled="noCustomerSaved"
            solo
            flat/>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center mb-2>
        <v-flex md5>
          <v-text-field
            v-model="form.last_name"
            color="k-orange"
            prepend-icon="fas fa-user"
            placeholder="Apellidos"
            :disabled="noCustomerSaved"
            solo
            flat/>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center mb-2 v-if="!noCustomerSaved">
        <v-flex md5 class="text-xs-right">
          <a @click="noCustomerForm = false">
            Es cliente
          </a>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex md5 class="text-xs-right">
          <v-btn color="k-orange-linear" class="mr-0" @click="saveNoCustomer" :disabled="disableSaveButton || loading">
            Guardar
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import EventBus from '@/event-bus';

export default {
  components: {
    VuePerfectScrollbar,
  },
  destroyed() {
    this.cancelToken.cancel('Canceled by user');
  },
  data() {
    const emptyForm = {
      fiscal_id: '',
      first_name: '',
      last_name: '',
    };
    return {
      emptyForm,
      loading: false,
      customers: [],
      fiscal_id: '',
      customer_name: '',
      noCustomerForm: false,
      form: { ...emptyForm },
      noCustomerSaved: false,
      customerSelected: false,
      cancelToken: this.axios.CancelToken.source(),
    };
  },
  computed: {
    currentCall() {
      return this.$store.state.dialerV2.currentCall;
    },
    disableSaveButton() {
      if (this.noCustomerSaved) {
        return true;
      }

      let disabled = true;
      Object.keys(this.form).forEach((key) => {
        disabled = disabled && String(this.form[key]).trim() === '';
      });
      return disabled;
    },
  },
  methods: {
    async selectCustomer(customer) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      if (this.customerSelected) {
        this.loading = false;
        return;
      }

      this.customerSelected = true;

      const selectedCustomer = {
        account:      customer.account,
        fiscal_id:    customer.fiscal_id,
        full_name:    customer.name || `${customer.first_name}${customer.last_name ? ` ${customer.last_name}` : ''}`,
        last_name:    customer.last_name,
        first_name:   customer.first_name,
        customer_id:  customer.id,
      };

      const result = await this.axios.post('/call_center/incoming_call/update', {
        ...selectedCustomer,
        phone: this.currentCall.phone,
        timestamp: this.currentCall.timestamp,
      })
      .then(() => true)
      .catch(() => false);

      if (!result) {
        this.customerSelected = false;
        this.loading = false;
        EventBus.$emit('error', 'Ocurrio un error, intente nuevamente');
        return;
      }

      const currentCall = {
        ...this.currentCall,
        ...selectedCustomer,
      };

      this.$store.commit('dialerV2/SET_CURRENT_CALL', currentCall);
      this.$store.commit('dialer/ADD_CALL_TO_SAVE', currentCall);

      Vue.router.push(`/customers/${currentCall.customer_id}/show`);
      this.customerSelected = false;
      this.loading = false;
    },
    async saveNoCustomer() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const selectedCustomer = {
        fiscal_id:  this.form.fiscal_id,
        full_name:  this.form.name || `${this.form.first_name}${this.form.last_name ? ` ${this.form.last_name}` : ''}`,
        last_name:  this.form.last_name,
        first_name: this.form.first_name,
      };
      const result = await this.axios.post('/call_center/incoming_call/update', {
        ...selectedCustomer,
        phone: this.currentCall.phone,
        timestamp: this.currentCall.timestamp,
      })
      .then(() => true)
      .catch(() => false);

      if (!result) {
        EventBus.$emit('error', 'Ocurrio un error, intente nuevamente');
        this.loading = false;
        return;
      }

      const currentCall = {
        ...this.currentCall,
        ...selectedCustomer,
      };

      this.$store.commit('dialerV2/SET_CURRENT_CALL', currentCall);
      this.$store.commit('dialer/ADD_CALL_TO_SAVE', currentCall);
      this.noCustomerSaved = true;
      this.loading = false;
    },
    getCustomers() {
      this.customers = [];
      this.cancelToken.cancel('Canceled by user');
      if (String(this.fiscal_id).trim() || String(this.customer_name).trim()) {
        this.cancelToken = this.axios.CancelToken.source();
        let filter = '';
        if (this.fiscal_id && this.customer_name) {
          filter = 'both';
        } else {
          if (this.fiscal_id) {
            filter = 'account';
          } else {
            filter = 'name';
          }
        }
        this.axios.get('customers/v2', {
          params: {
            filter,
            search: this.fiscal_id,
            name: this.customer_name,
            paginate: 0,
            fields: 'id,account,name,first_name,last_name',
          },
          cancelToken: this.cancelToken.token,
        }).then(({ data }) => {
          this.customers = data;
        }).catch(() => {});
      }
    }
  },
  watch: {
    fiscal_id: _.debounce(function() {
      this.getCustomers();
    }, 500),
    customer_name: _.debounce(function() {
      this.getCustomers();
    }, 500),
  },
};
</script>


// WEBPACK FOOTER //
// src/components/CallCenter/IncomingCall.vue